module.exports = __webpack_public_path__ + "img/htit5.901e7927.png";